export const isEscapeButton = (key: string) => {
  return key === 'Escape';
};
